import { default as RSelect } from 'react-select';
import { SelectOption } from '../../globals/interfaces';
import { useMemo } from 'react';
import { FormGroup, Label } from 'reactstrap';

export default function Select<T>({
    options,
    onChange,
    value,
    width,
    disabled,
    label
}: {
    options: Array<SelectOption<T>>;
    onChange: (option: SelectOption<T> | null) => void; // allow clear
    value: string | number | null | undefined;          // allow missing/clear
    width?: number;
    disabled?: boolean;
    label?: string;
}) {

    // Do NOT mutate props; copy before sorting, and memoize
    const sortedOptions = useMemo(
        () => [...options].sort((a, b) => a.label.localeCompare(b.label)),
        [options]
    );

    // Derive the selected option from the primitive `value`
    const selectedOption = useMemo(
        () => sortedOptions.find(o => o.value === value) ?? null,
        [sortedOptions, value]
    );

    const customStyles = {
        container: (provided: any) => ({ ...provided, width: width || '100%' }),
        menu: (provided: any) => ({ ...provided, zIndex: 9999 }),
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
    };

    return (
        <FormGroup>
            {label && <Label>{label}</Label>}
            <RSelect
                options={sortedOptions}
                value={selectedOption}
                onChange={(opt) => onChange(opt as SelectOption<T> | null)}
                styles={customStyles}
                isDisabled={disabled}
                isMulti={false}
            // if you want to render the menu in a portal, add menuPortalTarget={document.body}
            />
        </FormGroup>
    );
}
